import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ShProgressLabelComponent } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { ProgressCell } from './progress-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-progress-cell',
    templateUrl: './progress-cell.component.html',
    imports: [CommonModule, ShProgressLabelComponent]
})
export class ShProgressCellComponent extends ShBaseCell {
    @Input() public cell!: ProgressCell;
}
